import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const PositionsDetailsLoading: React.FC = () => {
  return (
    <tbody>
      {times(4).map(key => (
        <tr key={key}>
          {times(8).map(_key => (
            <td key={_key}>
              <Shimmer width="100%" height={20} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};
